var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"prismic-image-list img-fluid",attrs:{"src":_vm.image,"width":"150","height":"150","alt":_vm.alt,"loading":"lazy"}}),_vm._v(" "),_c('prismic-rich-text',{staticClass:"prismic-text-list text-center align-items-center justify-content-center",attrs:{"field":_vm.title}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }